// extracted by mini-css-extract-plugin
export default {"header":"styles_header__YU8Zn","content":"styles_content__Ls7av","logo":"styles_logo__uO33l","username":"styles_username__jyhaP","exit_button":"styles_exit_button__UpNHv"};